import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/signatures`;

export const signatureService = {
  async signEntity(data) {
    const response = await axios.post(`${API_BASE}/sign`, data);
    return response.data;
  },

  async verifySignature(signatureId, content) {
    const response = await axios.post(`${API_BASE}/verify/${signatureId}`, { content });
    return response.data;
  },

  async getSignaturesForEntity(entityType, entityId) {
    const response = await axios.get(`${API_BASE}/${entityType}/${entityId}`);
    return response.data;
  },
};

export default signatureService;
